import React, { PropTypes } from 'react';
import CreateAgentForm from './AgentForm';

const AgentForm = CreateAgentForm('AgentAddForm', () => ({}));

const AgentAddForm = React.createClass({
    propTypes: {
        onSuccess: PropTypes.func,
        onCancel: PropTypes.func
    },
    handleSubmit: function(selectedAgent) {
        const { onSuccess } = this.props;
        if(onSuccess) {
            onSuccess(selectedAgent);
        }
    },
    render: function() {
        const { onCancel } = this.props;
        return <div>
            <AgentForm onValid={this.handleSubmit} onCancel={onCancel} />
        </div>;
    }
});

export default AgentAddForm;


// WEBPACK FOOTER //
// ./src/components/common/AgentSelection/AgentAddForm.jsx